<template>
  <div class="step step--school-select">
    <button-back @back="back"></button-back>
    <div class="text-center">
      <div align-h="center">
        <div xl="4" md="8" sm="12">
          <div class="mb-4">
            <icon-school class="step__icon" />
            <h2>Which ones?</h2>
            <p>Enter the official names of up to 3 schools in the United States that offer bachelor’s degrees.</p>
          </div>
          <div class="step__buttons">
            <!-- <select v-model="user.schools" multiple>
              <option v-for="school in lists.schools" v-bind:value=school.UNITID v-bind:key=school.UNITID>{{ school.INSTNM }} ({{ school.STABBR }})</option>
            </select> -->
            <div class="step__multiselect">
              <multiselect ref="schoolSelect" v-model="user.schools" :options="schools" :multiple="true" placeholder="" track-by="INSTNM" :max="max" @input="onChange" @search-change="searchChange" @open="onToggle" @close="onToggle" :internal-search="false" :loading="isLoading" :options-limit="5000">
                <template slot="tag" slot-scope="{ option, remove }">
                  <span class="custom__tag">
                    <span class="custom__tag-label">Enter college name</span>
                    <span>{{ option.INSTNM }} ({{ option.STABBR }})</span><span class="custom__remove" @click="remove(option)"></span>
                  </span>
                </template>
                <template slot="clear" slot-scope="props">
                  <div class="multiselect__clear" v-if="user.schools.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
                </template>
                <span slot="noResult" slot-scope="{ search }">We can’t find a match for {{ search }}. Try entering the school’s full name.</span>
                <template slot="maxElements">
                  <span></span>
                </template>
                <template slot="option" slot-scope="{ option, search }">
                  <span><span v-html="customLabel(option, search)"></span> <span class="text-uppercase">({{ option.STABBR }})</span></span>
                </template>
              </multiselect>
              <div class="multiselect__label">
                Enter college name
              </div>
            </div>
            <!-- <a href="#" class="btn btn-link secondary mb-3">Add another school +</a> -->

            <b-button class="" variant="primary" block v-on:click="submit" :disabled="user.schools.length < 1">Continue</b-button>
          </div>
        </div>
      </div>
      <div class="text-left no-gutters" align-h="center">
        <disclaimer />
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ButtonBack from '../buttons/Back.vue'
import IconSchool from '../animatedicons/IconSchool.vue'
import Disclaimer from '../Disclaimer.vue'
import { ajaxFindSchool } from '../schoolApi.js'

export default {
  name: 'SchoolSelectStep',
  props: {
    user: Object,
    lists: Object
  },
  data (){
    return {
      schools: this.lists.schools.sort(),
      max: 3,
      isLoading: false
    }
  },
  components: {
    IconSchool,
    ButtonBack,
    Multiselect,
    Disclaimer,
  },
  mounted: function(){
    this.onChange();
  },
  methods: {
    onToggle: function(){
      var _this = this;
      this.isLoading = true
      ajaxFindSchool('', _this.lists.schools.sort()).then(response => {
        _this.schools = response
        _this.isLoading = false
      })
    },
    customLabel: function(option, search){
      if( search !== '' &&  `${option.INSTNM}`.toLowerCase().split(search).length > 1) {
        var oldHTML = `${option.INSTNM}`;
        var regex = new RegExp('(' + search + ')', 'i');
        return oldHTML.replace(regex, '<span class="highlight">$1</span>')
      } else {
        return `${option.INSTNM}`;
      }
    },
    searchChange: function(searchQuery){
      this.isLoading = true
      var _this = this;
      ajaxFindSchool(searchQuery, _this.lists.schools).then(response => {
        response.sort(function(a, b){
          var x = a.UGDS > b.UGDS ? -1 : 1;
          return x;
        });
        _this.schools = response
        _this.isLoading = false
      })
    },
    onChange: function(){
      setTimeout(function(){
        var container = this.$refs.schoolSelect.$el.parentElement;
        var searchInput = this.$refs.schoolSelect.$refs.search;

        if ( this.$refs.schoolSelect.value.length >= this.max ) {
          searchInput.style.display = 'none';
          searchInput.setAttribute('disabled', 'disabled');
          container.classList.add('limit');
        } else {
          searchInput.style.display = 'block';
          searchInput.removeAttribute('disabled');
          container.classList.remove('limit');
        }
      }.bind(this), 0);
    },
    back: function () {
      this.user.schoolKnown = null;
      this.$emit('back');
    },
    submit: function () {
      this.$emit('completed');
    },
  },
}
</script>

<style scoped>
</style>
